import { ShareableItem } from '@features/share';
import { Clip } from '../types';

export const mapClipToShareableItem = (clip: Clip): ShareableItem => {
    return {
        id: parseInt(clip.id, 10),
        name: clip.clipName,
        hasProxy: clip.hasProxy,
    };
};
